import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * チェックイン履歴
 *
 * 自分のチェックイン履歴を取得
 */
export class FetchAdmission implements APIRequest<Monitaro.FetchAdmissionResponse> {
  response: Monitaro.FetchAdmissionResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/admissions`
  }
}

/**
 * チェックイン
 *
 * 担当病院のQRコードを読んでチェックイン
 */
export class CheckIn implements APIRequest<Monitaro.CheckInResponse> {
  response: Monitaro.CheckInResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: Monitaro.CheckInRequest
  constructor(area: string, params: Monitaro.CheckInRequest) {
    this.params = params
    this.path = `/admissions/${area}`
  }
}

/**
 * チェックアウト
 *
 * 担当病院のQRコードを読んでチェックアウト
 */
export class CheckOut implements APIRequest<Monitaro.CheckOutResponse> {
  response: Monitaro.CheckOutResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  params: Monitaro.CheckOutRequest
  constructor(area: string, params: Monitaro.CheckOutRequest) {
    this.params = params
    this.path = `/admissions/${area}`
  }
}

/**
 * チェックイン情報の更新
 *
 * チェックイン、チェックアウト以外の情報を変更する
 */
export class PatchAdmission implements APIRequest<Monitaro.PatchAdmissionResponse> {
  response: Monitaro.PatchAdmissionResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PATCH
  params: Monitaro.AdmissionRequest
  constructor(admission: string, params: Monitaro.AdmissionRequest) {
    this.params = params
    this.path = `/admissions/${admission}`
  }
}
